<template>
  <div class="acomodar">
    <Topas class="text-center mt-3" />
    <multiplataforma class="mt-2 pb-3" />
    
    <dashboardPrincipal v-if="permisoVisualizador != 11 && Trabacceso == 1" />
  </div>
</template>

<script>
import dashboardPrincipal from "@/components/Plataforma/PerfilUsuario.vue";
import Topas from "@/components/Plataforma/TopasVisual.vue";
import Multiplataforma from "@/components/Plataforma/DashboardPrincipal.vue";
import { mapGetters } from "vuex";
export default {
  name: "SolimanologMultiplataformas",
  components: {
    Multiplataforma,
    Topas,
    dashboardPrincipal,
  },

  data() {
    return {
      permisoVisualizador:""
    };
  },

  mounted() { 
        this.permisoVisualizador = localStorage.getItem("idPerfil");

  },

  created() {
    this.$store.dispatch("acciones/CambioNavbar", false);
        this.$store.dispatch('auth/initializeFromLocalStorage');  // Cambia 'auth' por el nombre de tu módulo Vuex

  },

  computed: {
    ...mapGetters("acciones", ["EstadoBotonUsuarios"]),
    ...mapGetters('auth' , ['Trabacceso'])
  },
  methods: {},
};
</script>

<style scoped>
</style>
